import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toaster } from "../../actions/showToast";

export default function AddNote(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onClickAddNote = () => {
    // console.log("--Add a note..", props);
    dispatch(toaster(t("Click a point to add a button"), "warning"));
    props.changeMyTool("addnote");
  };
  return (
    <li onClick={onClickAddNote}>
      <span
        className={`button normal-btn next-page ${
          props.shouldShowButtonLabels ? "show-label-span" : ""
        } ${
          props.activeButton === "addnote" ? "active" : ""
        }`}
        title={t("Add Note")}
        data-tip={t("Add Note")}
      >
        <img
          src={require("../../assets/img/svg/tools-addnote2.svg")}
          alt={t("Add Note")}
        />
        {props.shouldShowButtonLabels && <span className="show-label-text">{t("Note")}</span>}
      </span>
    </li>
  );
}
